module.exports = __webpack_public_path__ + "img/wap_xen1.ba7e62e6.jpg";